function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_163)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.9972 15.7499L21.9994 15.7499C22.9545 15.7581 23.7381 14.9773 23.75 14.0042L23.75 2.0063C23.7462 1.53569 23.5589 1.08617 23.2297 0.756802C22.9014 0.428269 22.4589 0.246149 21.9972 0.250071L2.00064 0.250062C1.54109 0.246149 1.09858 0.428269 0.770279 0.756802C0.441145 1.08617 0.253838 1.53569 0.250008 2.00426L0.25 13.9937C0.253838 14.4643 0.441145 14.9138 0.770279 15.2432C1.09858 15.5717 1.54109 15.7538 2.00277 15.7499H21.9972ZM21.9962 16.2499C21.9958 16.2499 21.9955 16.2499 21.9951 16.2499L21.9972 16.2499H21.9962Z",
  fill: "white",
  stroke: "black",
  strokeOpacity: 0.2,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0021 2.0518V2.0358H14.0021V2.0518C17.1376 2.28124 19.5642 4.89198 19.5642 8.0358C19.5642 11.1796 17.1376 13.7904 14.0021 14.0198V14.0358H10.0021V14.0198C6.86669 13.7904 4.44001 11.1796 4.44001 8.0358C4.44001 4.89198 6.86669 2.28124 10.0021 2.0518Z",
  fill: "#0165AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6021 11.4278C13.0374 10.9175 13.9962 9.55908 13.9962 8.03578C13.9962 6.51249 13.0374 5.15407 11.6021 4.64378V11.4278ZM9.20212 4.64378C7.76684 5.15407 6.80808 6.51249 6.80808 8.03578C6.80808 9.55908 7.76684 10.9175 9.20212 11.4278V4.64378ZM10.4021 13.2358C7.53024 13.2358 5.20212 10.9077 5.20212 8.03578C5.20212 5.1639 7.53024 2.83578 10.4021 2.83578C13.274 2.83578 15.6021 5.1639 15.6021 8.03578C15.6021 10.9077 13.274 13.2358 10.4021 13.2358Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_163"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 16,
  fill: "white"
})));
function SvgDinersClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/diners_club.4263f660bee77d4f0268403a0293aedc.svg";
export { ForwardRef as ReactComponent };